import proj4 from "proj4";

export function utmFromLatLon(lat: number, lon: number) {
	// This computes UTM on WGS84 (correct for PWA geolocation).
	// If proj4 isn’t available, stub this and rely on manual entry.

	const zoneNumber = Math.floor((lon + 180) / 6) + 1; // 1..60
	const hemisphere: "N" | "S" = lat >= 0 ? "N" : "S";
	const utmProj = `+proj=utm +zone=${zoneNumber} +datum=WGS84 +units=m +no_defs${hemisphere === "S" ? " +south" : ""}`;

	// proj4 expects [lon, lat] for EPSG:4326
	const [easting, northing] = proj4("EPSG:4326", utmProj, [lon, lat]) as [number, number];

	return { zoneNumber, hemisphere, easting, northing };
}
